import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'twain-sport-fe-mono/components/Tooltip';
import { ResultType } from 'twain-sport-fe-mono/enums';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { WonLostAbbrevation } from './enums/WonLostAbbrevation';
import { ResultsDirection } from './enums/ResultsDirection';
import classes from './StatisticsResult.module.scss';

interface IProps {
    results?: ResultType[];
    direction: ResultsDirection; // from newest to oldest
}

const classesMap = {
    [ResultsDirection.TO_RIGHT]: classes.toRight,
    [ResultsDirection.TO_LEFT]: classes.toLeft,
};

const resultMap = {
    [ResultType.WON]: WonLostAbbrevation.WON,
    [ResultType.LOST]: WonLostAbbrevation.LOST,
    [ResultType.TIE]: '',
    [ResultType.TECH_LOSS]: '',
};

const defaultProps: Partial<IProps> = {
    results: [],
};

export const StatisticsResult: React.FC<IProps> = (props) => {
    return (
        <div
            className={classNames(classesMap[props.direction], classes.container)}
            role="button"
            tabIndex={0}
        >
            {props.results.map((result, index) => (
                <div
                    key={index}
                    className={classNames(classes.resultsItem, {
                        [classes.won]: result === ResultType.WON,
                    })}
                >
                    {index === 0 && (
                        <Tooltip className={classes.tooltip} isSmall>
                            {translationProvider.string('last_game')}
                        </Tooltip>
                    )}
                    {resultMap[result]}
                </div>
            ))}
        </div>
    );
};

StatisticsResult.defaultProps = defaultProps;
